import React from 'react';
import { globalAvailableIndexes } from '../../utils/indexes';
import theme from '../../theme';
import { Index } from '../../common/utils/indexes';
import { Stack, useMediaQuery } from '@mui/material';
import AreaInfo from './AreaInfo';
import { FieldDataItem } from '../../common/classes/field_data_item';
import IndexSelector from './IndexSelector';
import BackButton from '../BackButton';

export interface FloatingTopBarProps {
  currentAnalysisUUID?: string;
  currentIndex?: string;
  selectedIndex?: Index;
  availableIndexes: string[];
  onIndexChange: (index: Index) => void;
  field?: {
    id: number;
    name: string;
  } | null;
  agricultureAnalysisData?: {
    id: number;
    phase: string;
  };
  fieldDataItems?: FieldDataItem[];
  fieldBoundary?: google.maps.LatLngLiteral[];
  isCompare?: boolean;
}

function FloatingTopBar(props: FloatingTopBarProps) {
  const [ filteredSelectedIndex, setFilteredSelectedIndex ] = React.useState<Index[]>([]);
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));
  const smallScreen = props.isCompare || isMobile;

  React.useEffect(() => {
    let filteredIndexes: Index[] = [];
    for (const index of globalAvailableIndexes) {
      if(props.isCompare && index.noCompare) {
        continue;
      }

      if (index.showAlways || props.availableIndexes.includes(index.id)) {
        filteredIndexes.push(index);
      }
    }
    setFilteredSelectedIndex(filteredIndexes);
  }, [props.availableIndexes, props.isCompare]);

  return (
    <React.Fragment>
      <Stack 
        direction="row"
        spacing={2}
        sx={{
          position: 'absolute',
          top: 8,
          left: 8,
          right: 8,
          zIndex: 10000
        }}
        alignItems={'start'}
        justifyContent={'space-between'}
      >
        <BackButton />
        <IndexSelector
          selectedIndex={props.selectedIndex}
          availableIndexes={filteredSelectedIndex}
          onIndexChange={props.onIndexChange}
          isMobile={smallScreen}
          style={{
            height: 55,
            flexGrow: 1
          }}
        />
        <AreaInfo
          width={350}
          collapsedHeight={55}
          minimized={smallScreen}
          field={props.field}
          agricultureAnalysisData={props.agricultureAnalysisData}
          fieldDataItems={props.fieldDataItems}
          fieldBoundary={props.fieldBoundary}
          photogrammetry
        />
      </Stack>
    </React.Fragment>
  );
}

export default FloatingTopBar;
